const DIET_INITIAL_STATE = {
  isFetchLoading: false,
  isSimpleDetailsLoading: false,
  isExcludedAllergensDetailsLoading: false,
  isExcludedIngredientsDetailsLoading: false,
  fetchError: undefined,
  simpleDetailsError: undefined,
  excludedAllergensDetailsError: undefined,
  excludedIngredientsDetailsError: undefined,
  data: undefined,
  isExcludedIngredientsDirty: false,
  isExcludedAllergensDirty: false,
  isSimpleDetailsDirty: false,
  isImageDetailsLoading: false,
  imageDetailsError: undefined,
}

export default DIET_INITIAL_STATE
